import API_ENDPOINTS from "../config/apiEndpoints";
import { ensureOk, requestWithAuth } from "./apiClient";

export const apiCentrosService = {
  getById: async (idCentro) => {
    const response = await requestWithAuth(API_ENDPOINTS.CENTRO.ONE(idCentro));

    return response.json();
  },
  putById: async (idCentro, json) => {
    const response = await requestWithAuth(API_ENDPOINTS.CENTRO.ONE(idCentro), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

    return response.json();
  },
  deleteById: async (idCentro) => {
    const response = await requestWithAuth(API_ENDPOINTS.CENTRO.ONE(idCentro), {
      method: "DELETE",
    });

    return response.json();
  },
  getAllPageable: async (idEmpresa, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.CENTRO.ALL_PAGEABLE(idEmpresa, page, size),
      {
        method: "GET",
      }
    );

    return response.json();
  },
  getAllCentros: async (idEmpresa) => {
    try {
      const response = await requestWithAuth(API_ENDPOINTS.CENTRO.ALL(idEmpresa));
      ensureOk(response, "Error al obtener datos paginados");
      return response.json();
    } catch (error) {
      console.error("Error en la carga de datos paginados:", error);
      throw error;
    }
  },
  create: async (json) => {
    const response = await requestWithAuth(API_ENDPOINTS.CENTRO.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

    return response.json();
  },
};
